import { useQuery } from "@tanstack/react-query";
import axios from "../../libs/axios";
import { store } from "../../store/useStore";

export function useApplicationStagesAndReasons({
  stage_id,
  params,
  enabled = true,
}: {
  stage_id: string;
  params?: any;
  enabled?: boolean;
}) {
  const active_device = store.auth.activeDeviceIdentifier();

  return useQuery({
    queryKey: ["application", "status", "stage", stage_id],
    queryFn: async () => {
      const { data } = await axios.get(
        `/applications-v2/stages_and_reasons?stage_id=${stage_id}`,
        {
          params: {
            ...params,
          },
          headers: {
            "fi-device-number": active_device,
          },
        }
      );

      return data?.data;
    },
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    enabled,
  });
}


